import { Link } from 'react-router-dom';
import LegalPage, { Section } from './components/LegalPage';

// Served from the app's own origin rather than an add-on store, so it is a
// plain <a> — a router Link would try to navigate the SPA to a file.
//
// `/extensions/`, not `/extension/`: the edge proxy serves the signed .xpi
// under the plural path (with the x-xpinstall type that makes Firefox offer
// to install rather than download). The singular path matches no rule, so it
// falls through to the SPA and hands Firefox an HTML page instead.
const FIREFOX_XPI = 'https://dissona.app/extensions/firefox/latest.xpi';

const CHROME_STORE =
  'https://chromewebstore.google.com/detail/dissona/eapgafmmngfjieocdjkncfimiomnehbj';

function Extensions() {
  return (
    <LegalPage title="Browser extensions" lastUpdated={null}>
      <Section title="Add the page you are reading">
        <p>
          The Dissona extension puts whatever you are reading into one of your projects without
          leaving the page. No copying the address, no switching tabs, no finding the project
          again later — you click once and carry on reading.
        </p>
        <p>
          Dissona fetches the article in the background and turns it into a chapter, so it is
          waiting as audio the next time you have your hands full.{' '}
          <Link to="/docs" className="link hover:underline">The documentation</Link> covers what
          happens to a page once it arrives.
        </p>
      </Section>

      <Section title="Firefox">
        <p>Available now.</p>
        <p>
          <a
            href={FIREFOX_XPI}
            className="mt-2 inline-flex h-10 items-center justify-center rounded-lg bg-primary px-4 text-sm font-bold text-white hover:bg-primary/90 transition-colors"
          >
            Install for Firefox
          </a>
        </p>
        <p>
          Firefox will ask you to confirm the installation. You will be signed in to the extension
          with the same account you use here.
        </p>
      </Section>

      <Section title="Chrome">
        <p>Available now, from the Chrome Web Store.</p>
        <p>
          <a
            href={CHROME_STORE}
            className="mt-2 inline-flex h-10 items-center justify-center rounded-lg bg-primary px-4 text-sm font-bold text-white hover:bg-primary/90 transition-colors"
          >
            Install for Chrome
          </a>
        </p>
        <p>
          You will be signed in to the extension with the same account you use here.
        </p>
      </Section>
    </LegalPage>
  );
}

export default Extensions;
